import Registrable from './Registrable'

import Draggable from './Draggable'
import Droppable from './Droppable'
import DroppableBubble from './DroppableBubble'

const TYPES = { DRAGGABLE: 0, DROPPABLE: 1, DROPPABLE_BUBBLE: 2 }
const DIRECTIONS = { DOWNWARDS: 0, UPWARDS: 1 }
const DRAGGABLE_PLACEHOLDER = { isPlaceholder: true, style: { transform: '' } }

class DraggableFactory extends Registrable {
  register (type, direction = null, el, component = null) {
    super.register(el, this._createInstance(type, direction, el, component))
  }

  unregister (el) {
    super.unregister(el)
  }

  _createInstance (type, direction, el, component) {
    switch (type) {
      case TYPES.DRAGGABLE:
        return new Draggable(el, component)
      case TYPES.DROPPABLE:
        return new Droppable(el)
      case TYPES.DROPPABLE_BUBBLE:
        return new DroppableBubble(el, component, direction)
    }
  }
}

export default new DraggableFactory()

export {
  TYPES as Types,
  DIRECTIONS as Directions,
  DRAGGABLE_PLACEHOLDER as DraggablePlaceholder
}
